module.exports = __webpack_public_path__ + "img/073624.3191d865.png";